import { ApiClient } from './apiClient';
import { 
  AddressValidationRequest, 
  AddressValidationResponse 
} from '../types/address';

// API Response wrapper type
interface ApiResponseWrapper<T> {
  data: T;
  status: string;
  message: string;
}

/**
 * Address validation service
 */
export class AddressValidationService {
  /**
   * Validate an address using the API
   */
  static async validateAddress(
    address: AddressValidationRequest
  ): Promise<AddressValidationResponse> {
    try {
      const response = await ApiClient.post<ApiResponseWrapper<AddressValidationResponse>, AddressValidationRequest>(
        '/address/validate',
        address
      );
      
      // Extract the nested data from the API wrapper
      return response.data;
    } catch (error) {
      console.error('Address validation error:', error);
      throw error;
    }
  }
}

export default AddressValidationService; 